"use client";

import React from "react";
import { cn } from "@/lib/utils";
import type { LandingTabId, LandingToggle as LandingToggleData } from "./types";

interface LandingToggleProps {
	data: LandingToggleData;
	value: LandingTabId;
	onChange: (id: LandingTabId) => void;
}

export const LandingToggle: React.FC<LandingToggleProps> = ({
	data,
	value,
	onChange,
}) => {
	return (
		<div
			role="tablist"
			aria-label="Savings view"
			className="flex w-fit mx-auto items-stretch rounded-[6px] bg-white border border-[var(--automint-onboarding-dotted-line)] shadow-sm overflow-hidden"
		>
			{data.tabs.map((tab) => {
				const active = tab.id === value;
				return (
					<button
						key={tab.id}
						type="button"
						role="tab"
						aria-selected={active}
						onClick={() => onChange(tab.id)}
						className={cn(
							"px-5 md:px-6 py-2.5 md:py-2 text-sm font-medium transition-colors",
							active
								? "bg-automint-black text-automint-neon"
								: "bg-transparent text-automint-black hover:bg-[var(--automint-onboarding-listbox-hover-light)]",
						)}
					>
						{tab.label}
					</button>
				);
			})}
		</div>
	);
};
